import { OrderBoolAscendingVariantIcon } from './OrderBoolAscendingVariantIcon';

/**
 * author: Simran
 * id FA5DB7BA-69CB-4DF5-9DE9-B0681889CB2D
 * name order-bool-ascending-variant
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/order-bool-ascending-variant.svg
 * tags
 * - Text / Content / Format 
 */
export const OrderCheckboxAscendingIcon = OrderBoolAscendingVariantIcon;
export default OrderCheckboxAscendingIcon